/**
 * @author Sarthak Sharma.
 * @since 05-02-2024.
 * @type {string} Folder action types.
 */

export const SET_LOADING = '[RECRUITER_FOLDER] SET_LOADING';
export const SET_FOLDER_LIST = '[RECRUITER_FOLDER] SET_FOLDER_LIST';

export const SET_ALL_ARTIST_LIST = '[RECRUITER_FOLDER] SET_ALL_ARTIST_LIST';
export const APPEND_ALL_ARTIST_LIST = '[RECRUITER_FOLDER] APPEND_ALL_ARTIST_LIST';
export const SET_ALL_ARTIST_LIST_META = '[RECRUITER_FOLDER] SET_ALL_ARTIST_LIST_META';

export const SET_FOLDER_STACK = '[RECRUITER_FOLDER] SET_FOLDER_STACK';
export const SET_SELECTED_FOLDER = '[RECRUITER_FOLDER] SET_SELECTED_FOLDER';
export const SET_SELECTED_SAVED_FOLDER = '[RECRUITER_FOLDER] SET_SELECTED_SAVED_FOLDER';
export const SET_CURRENT_FOLDER = '[RECRUITER_FOLDER] SET_CURRENT_FOLDER';

export const SET_SELECTED_ARTISTS = '[RECRUITER_FOLDER] SET_SELECTED_ARTISTS';

export const POP_LAST_FOLDER = '[RECRUITER_FOLDER] POP_LAST_FOLDER';

export const SET_LIST_TYPE = '[RECRUITER_FOLDER] SET_LIST_TYPE';